import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 20, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 20 20"
    {...rest}
  >
    <path
      fill={color}
      d="M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm4.57 13.4a.83.83 0 0 1-1.15 1.2l-.02-.02-3.25-3.25a.21.21 0 0 0-.3 0L6.6 14.58a.84.84 0 0 1-1.18 0 .83.83 0 0 1 0-1.18l3.25-3.25a.2.2 0 0 0 0-.3L5.42 6.6A.83.83 0 1 1 6.6 5.43l3.25 3.25a.2.2 0 0 0 .3 0l3.25-3.25a.83.83 0 0 1 1.22 1.12l-.05.05-3.25 3.25a.2.2 0 0 0 0 .3l3.26 3.25z"
    />
  </svg>
);
